import { Routes } from '@angular/router';
import { ZpvDetailComponent } from './zpv-detail/zpv-detail.component';
import { ZpvDetailResolver } from './zpv-detail/zpv-detail-resolver';

export const PersonZpvRoutes: Routes = [
  {
    path: 'zentrale-personen',
    loadChildren: () => routes,
    providers: [ZpvDetailResolver]
  }
];

const routes: Routes = [
  {
    path: 'detail/:id',
    component: ZpvDetailComponent,
    resolve: {
      entity: ZpvDetailResolver
    }
  }
];
